import React from "react";
import Weather from "./Weather";

function App() {
  return (
    <div className="App">
      <Weather defaultCity="Los Angeles" />
    </div>
  );
}

export default App;
